import { Navigate } from "react-router-dom";
import { useAuth, useRole } from "@/context/AuthContext";

/**
 * Route guard for `/admin/*` paths.
 *
 * Non-admin users get bounced to `/` (the dashboard) -- the backend
 * still enforces authorization on each /admin/* endpoint, so this is
 * purely a UX shortcut to avoid showing pages that would 403 anyway.
 *
 * Mirrors the pattern of `ProtectedRoute` (auth check) but layers on
 * the role check via `useRole().isAdmin`.
 */
export default function AdminRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isAuthenticated, isLoading } = useAuth();
  const { isAdmin } = useRole();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
}
